import usFlag from "../assets/images/flags/us.jpg"
import russia from "../assets/images/flags/russia.jpg"

const languages = {
  rs: {
    label: "Russian",
    flag: russia,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
}

export default languages
